import { Component } from "@angular/core";
import { InfoSocieta } from "src/app/common/models/controparte";

declare var closeModal: any;
declare var openModal: any;

@Component({
  selector: "tlf-info-societa-modal",
  templateUrl: "./info-societa-modal.component.html",
})
export class InfoSocietaModalComponent {
  societa: InfoSocieta;
  randId: string;

  constructor() {
    this.randId = Math.floor(Math.random() * 1000).toString();
  }

  show(societa: InfoSocieta) {
    this.societa = societa;
    openModal("infoSocietaModal" + this.randId);
  }

  close() {
    /*setto la società a null in modo tale da resettare anche la view nell ngIf
    in particolare per le classi 'active' dei tab*/
    this.societa = null;
  }
}
